// import { UserIcon } from "lucide-react";
// import { config } from "../../Config";

const HeaderVD = () => {
  return (
    <div className="max-h-[5rem] shadow-lg w-screen bg-secondary-color">
      <div className="w-full max-h-[5rem] max-w-[85rem] mx-auto xl:px-4 px-6 py-5 flex justify-between items-center gap-2">
        <div className="w-full flex justify-start items-start gap-6">
          <img
            src="/tim/images/logos/logo-tim.webp"
            alt="Logo TIM"
            width={90}
            height={30}
          />
          <img
            src="/tim/images/logos/logo_topen_white.webp"
            alt="Logo Thopen Energy"
            width={110}
            height={30}
          />
        </div>
        {/* <div className="lg:px-2">
          <button
            onClick={(e) => {
              const aEl = document.createElement("a");
              aEl.href = config.url.urlLoginPortal;
              aEl.target = "_blank";
              aEl.click();
            }}
            className="max-md:hidden h-[3.313rem] px-6 py-4 rounded-xl border border-white justify-start items-center inline-flex hover:opacity-70 transition-all duration-150 ease-linear text-center text-white text-sm font-normal  leading-[21px] text-nowrap"
            aria-label="Área do associado"
          >
            Área do associado
          </button>
          <button
            onClick={(e) => {
              const aEl = document.createElement("a");
              aEl.href = config.url.urlLoginPortal;
              aEl.target = "_blank";
              aEl.click();
            }}
            className="md:hidden flex h-[3.313rem] justify-start items-center hover:opacity-70 transition-all duration-150 ease-linear"
            aria-label="Área do associado"
          >
            <UserIcon size={24} color="#fff" />
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default HeaderVD;
